import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import Hero from '../components/Hero';
import ContactForm from '../components/ContactForm';
import { SEO } from '../utils/seo';
import meta from '../seo/keywords';
import ContactImg from '../assets/images/hero-contact.jpg';
export default function Book() {
  const m = meta.book;
  return (
    <Box>
      <SEO title={m.title} description={m.description} canonical={m.canonical} />
      <Hero title="Schedule Your HVAC Service Now" subtitle="Pick a date that works for you and tell us what you need. We’ll confirm shortly." bgImage={ContactImg} />
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography variant="h2" gutterBottom>Book Appointment</Typography>
        <Typography color="text.secondary" paragraph>
          Share a few details and we’ll follow up to confirm your appointment window. For emergencies, please call (812) 555-0168.
        </Typography>
        <ContactForm />
      </Container>
    </Box>
  );
}
